import { create } from "zustand";

export const useRawPositionStore = create((set, get) => ({

    rawPositions: [],
    version: 0,   // 🔥 UI re-render trigger

    //-------------------------------------------
    // INITIAL LOAD
    //-------------------------------------------
    setInitialRawPositions: (positions) => {
        set({
            rawPositions: positions || [],
            version: get().version + 1,
        });
    },

    //-------------------------------------------
    // ADD / UPDATE POSITION (by ID)
    //-------------------------------------------
    addOrUpdateRawPosition: (incoming) => {
        set((state) => {
            // incoming handling might differ if wrapper 'position' key exists
            const positionData = incoming.position || incoming;
            const incomingId = String(positionData.id);

            const idx = state.rawPositions.findIndex(
                (p) => String(p.id) === incomingId
            );

            let newPositions;

            if (idx !== -1) {
                // console.log(
                //   `🔄 Updating Raw Position → ID: ${incomingId}, Symbol: ${positionData.symbol}`
                // );

                newPositions = [...state.rawPositions];
                newPositions[idx] = {
                    ...newPositions[idx],
                    ...positionData,
                    last_updated: new Date().toISOString(),
                };
            } else {
                // console.log(
                //   `🟢 Adding NEW Raw Position → ID: ${incomingId}, Symbol: ${positionData.symbol}`
                // );

                newPositions = [...state.rawPositions, positionData];
            }

            return {
                rawPositions: newPositions,
                version: state.version + 1,
            };
        });
    },

    //-------------------------------------------
    // REMOVE BY ID
    //-------------------------------------------
    removeRawPositionById: (id) => {
        if (!id) return;

        set((state) => ({
            rawPositions: state.rawPositions.filter(
                (p) => String(p.id) !== String(id)
            ),
            version: state.version + 1,
        }));
    },

}));
